<template>
  <div class="">
    <div class="head-title">自定义菜单</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>企业支持自定义微炬云SCRM员工端的左侧菜单栏，可以控制显示隐藏。</p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="">
      <div class="mMain">
        <el-button type="primary" @click="cleanSet()">重置菜单</el-button>
        <el-table :data="tableData" v-loading="tableLoading" style="width: 100%; margin-top: 1.0rem">
          <el-table-column prop="name" label="业务名称" >
          </el-table-column>
          <el-table-column prop="config_name" label="显示名称">
          </el-table-column>
          <el-table-column prop="type_name" label="是否启用" >
            <template slot-scope="scope">
              <span style="color: #67c23a" v-if="scope.row.type == 1">是</span>
              <span style="color: #f56c6c" v-if="scope.row.type == 2">否</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="300"  >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleClick(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="编辑业务" center :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="item" label-width="8.0rem">
        <el-form-item label="系统名称">
          <el-input v-model="item.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="显示名称">
          <el-input v-model="item.config_name"></el-input>
        </el-form-item>
        <el-form-item label="启用">
          <el-select v-model="item.type" placeholder="请选择">
            <el-option
              v-for="i in options"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitMenus">立即创建</el-button>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMenus()">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      item: {},
      options: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "2",
          label: "否",
        },
      ],
      tableLoading: true,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getMenus();
  },

  methods: {
    async getMenus() {
      const res = await this.axios({
        url: "/crm/Menu/get_menu",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
        },
      });
      this.tableLoading = false;
      if (res.data.code == 1) {
        this.tableData = res.data.data.menu;
      }
    },
    handleClick(e) {
      this.item = e;
      this.dialogVisible = true;
    },
    async submitMenus() {
      this.dialogVisible = false;
      let ind = this.tableData.findIndex((item) => {
        return item.name == this.item.name;
      });
      let arr = this.tableData.concat();
      arr.splice(ind, 1, this.item);
      const res = await this.axios({
        url: "/crm/Menu/insert_menu",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
          menu: JSON.stringify(arr),
        },
      });
      if (res.data.code == 1) {
        this.$message({
          message: res.data.msg,
          type: "success",
        });
        this.tableData = [];
        this.getMenus();
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    async cleanSet() {
      const res = await this.axios({
        url: "/crm/Menu/recover",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
        },
      });
      if (res.data.code == 1) {
        this.$message({
          message: res.data.msg,
          type: "success",
        });
        this.tableData = [];
        this.getMenus();
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
  },
};
</script>
  <style scoped>
  .el-button--text{padding-left:.0rem !important;}
</style>
  
  
  